<template>
    <div class="container" style="max-width: 100%">
        <!-- <section class="my-6">
        <Education is_editable />
      </section>
  
      <section class="my-6">
        <Research is_editable />
      </section> -->

        <section class="my-6">
            <div>
                <!-- HEADING -->
                <h2 class="title mb-5 has-text-weight-bold">Messages</h2>

                <FormErrors v-bind:errors="errors.detail" />

                <!-- MESSAGES RECORDS -->
                <div style="text-align: center;" v-if="next">
                    <button class="button is-info" v-on:click="load_more()">
                        Load more...
                    </button>
                </div>
                <ul v-if="messages.length === 0">
                    <li class="box has-text-centered is-centered has-text-weight-bold has-background-white">
                        No Messages
                    </li>
                </ul>
                <ul v-else class="">
                    <li v-for="(message, index) in messages" class="m-2" v-bind:key="index">
                        <MessageBox v-bind:is_editable="allow_editing" v-bind:message=message />
                    </li>
                </ul>
            </div>
        </section>
        <section>
            <div class="columns my-3 mx-1">
                <textarea class="textarea is-four-fifths mr-2" placeholder="Write your message here."
                    v-model="message.message"></textarea>
                <div class="">
                </div>
            </div>
        </section>
        <button class="button is-success" v-on:click="send_message()">
            Send
        </button>
    </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import axios from '../../api/my-axios';
import MessageBox from './MessageBox';
import InputBox from '../FormHelpers/InputBox';
import FormErrors from '../FormHelpers/FormErrors';

export default {
    components: {
        MessageBox,
        InputBox,
        FormErrors,
    },
    props: {
        is_editable: {
            type: Boolean,
            default: false,
        },
        profile_uid: {
            type: String,
            default: null,
        },
        user_role: {
            // "mentor" or "mentee"
            type: String,
            default: null,
        },
    },
    created() {
        this.get_messages();
    },
    computed: {
        ...mapState({
            user: 'user',
        }),
        ...mapGetters({
            role: 'role', // "mentor" or "mentee"
        }),
    },
    data() {
        return {
            allow_editing: false,
            messages: [],
            message: {
                message: '',
            },
            errors: {
                detail: null,
            },
            next: null
        }
    },
    methods: {
        get_messages() {
            axios.get(`/api/${this.user_role}/messages/?profile_uid=${this.profile_uid}&limit=10&offset=0`)
            .then((response) => {
                this.messages = response.data.results.reverse();
                this.next = response.data.next;
            })
        },

        load_more() {
            axios.get(this.next)
            .then((response) => {
                let messages = response.data.results.reverse();
                for (var i = 0; i < this.messages.length; i++) {
                    messages.push(this.messages[i]);
                }
                this.next = response.data.next;
                this.messages = messages;
            })
        },

        send_message() {
            this.message[this.user_role] = this.profile_uid;
            this.message["user"] = this.user.uid;
            console.log(this.role)
            this.message["read_by_"+this.role] = true;
            axios.post(`/api/${this.user_role}/messages/?profile_uid=${this.profile_uid}`, this.message)
            .then(() => {
                this.get_messages();
                this.message.message = "";
            })
        }
    }
}
</script>